module.exports = __webpack_public_path__ + "media/images/phone-77c4e2fcbccc22d5c0be475237014ef8.svg";